// Privy activé dès que l'App ID est fourni (dashboard.privy.io → VITE_PRIVY_APP_ID).
export const isPrivyEnabled: boolean = ((import.meta.env.VITE_PRIVY_APP_ID as string | undefined) ?? '').length > 8
